import Deposit from "./deposit.component";

export default Deposit;
